import {
  SET_AIDEA_SMART_ELEMENTS_PROCESSING,
  CLEAR_AIDEA_SMART_ELEMENTS_PROCESSING,
  APPLY_AIDEA_SMART_ELEMENTS,
} from "../common/actions";

/**
 * Ephemeral state slice that tracks in-flight Aidea Smart Elements
 * decomposition jobs by source box id. Lives OUTSIDE the undoGroup so it does
 * not pollute redux-undo history.
 *
 * Shape: { [boxId: string]: { jobId, percent, step, message } }
 */
export default function aideaSmartElementsProcessing(state = {}, action) {
  switch (action.type) {
    case SET_AIDEA_SMART_ELEMENTS_PROCESSING: {
      const { boxId, info } = action.payload;
      return { ...state, [boxId]: info };
    }
    case CLEAR_AIDEA_SMART_ELEMENTS_PROCESSING: {
      const { boxId } = action.payload;
      const next = { ...state };
      delete next[boxId];
      return next;
    }
    case APPLY_AIDEA_SMART_ELEMENTS: {
      const sourceBoxId = action.payload?.sourceBoxId;
      if (!sourceBoxId) return state;
      const next = { ...state };
      delete next[sourceBoxId];
      return next;
    }
    default:
      return state;
  }
}
